import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import Swal from "sweetalert2";
import Select from "react-select";
import ReCAPTCHA from "react-google-recaptcha";
import withReactContent from "sweetalert2-react-content";
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

const MySwal = withReactContent(Swal)

const ContactUs = () => {

  const userOptions = [
    { value: "Rider", label: "Rider" },
    { value: "Passenger", label: "Passenger" },
    { value: "Other", label: "Other" },
  ]
  const issueOptions = [
    { value: "Help with a trip", label: "Help with a trip" },
    { value: "Fare review", label: "Fare review" },
    { value: "Cash payment issues", label: "Cash payment issues" },
    { value: "Mobile Money payment support", label: "Mobile Money payment support" },
    { value: "Other Payment Issues", label: "Other Payment Issues" },
    { value: "Lost item", label: "Lost item" },
    { value: "Feedback about the driver or vehicle", label: "Feedback about the driver or vehicle" },
    { value: "Safety Feedback", label: "Safety Feedback" },
    { value: "Others", label: "Others" },
  ]

  const recaptchaRef = useRef(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [address, setAddress] = useState(null);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    phone_code: "256",
    phone_number: "256",
    user_type: "",
    issue_type: "",
    message: "",
    attachment: null
  });

  useEffect(() => {
      if (Object.keys(errors).length > 0) {
        const firstError = Object.keys(errors)[0];
        if (firstError) {
          const errorElement = document.querySelector(`.invalid-feedback`);
          if (errorElement) {
            const formGroup = errorElement.closest('.form-group');
            if (formGroup) {
              formGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }
      }
    }, [errors]);

  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true);
    } else {
      setCaptchaVerified(false);
    }
  };    

  const handlePhoneChange = (value, data) => {
    console.log("data is", data, value);
    setUserData({
      ...userData,
      phone_number: value,
      phone_code: data.dialCode
    });
    setErrors({ ...errors, phone_number: "" });
  };

  async function handleAddressChange(value) {
    setAddress(value);
    setErrors(prev => ({ ...prev, address:""}));
  }

  const handleUserInput = (field, value) => {
    setUserData({
      ...userData,
      [field]: value
    });
    setErrors({ ...errors, [field]: "" });
  };

  const validateUserData = () => {
    const newErrors = {};
    if (!userData.name.trim()) {
      newErrors.name = "Full Name is required";
    }

    if (!userData.email) {
      newErrors.email = "Email is required";
    }

    if (userData.email && !/\S+@\S+\.\S+/.test(userData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!userData.phone_number.slice(userData.phone_code.length).trim()) {
      newErrors.phone_number = "Phone Number is required";
    }

    if (!address?.label) {
      newErrors.address = "Address is required";
    }

    if (!userData.user_type) {
      newErrors.user_type = "User Type is required";
    }

    if (!userData.issue_type) {
      newErrors.issue_type = "Issue Type is required";
    }

    if (!userData.message.trim()) {
      newErrors.message = "Message is required";
    }

    if (userData.attachment) {
      const allowedTypes = ['application/pdf'];
      if (!allowedTypes.includes(userData.attachment.type)) {
        newErrors.attachment = 'Only PDF files are allowed';
      }
    }

    if (!captchaVerified) {
      newErrors.captcha = "Captcha verification is required";
    }

    setErrors(prev => ({ ...prev, ...newErrors }));
    return Object.keys(newErrors).length === 0;
  }

  const handleSubmit = () => {
		const isUserDataValid = validateUserData();

		if (isUserDataValid) {
			submitData();
		}
	};

  function submitData() {

    let userFormData = new FormData();
    userFormData.append('name', userData.name);
    userFormData.append('email', userData.email);
    userFormData.append('phone_code', `+${userData.phone_code}`);
    userFormData.append('phone_number', userData.phone_number.slice(userData.phone_code.length));
    userFormData.append('message', userData.message);
    userFormData.append('user_type', userData.user_type);
    userFormData.append('issue_type', userData.issue_type);
    userFormData.append('location', address.label);
    if (userData.attachment) {
      userFormData.append('attachment', userData.attachment);
    }
    MySwal.fire({
      title: "Submitting the form...",
      allowEscapeKey: false,
      allowOutsideClick: false,
    })
    MySwal.showLoading();
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/accounts/contact-us/`, userFormData)
      .then((response) => {
        MySwal.close();
        MySwal.fire({
          icon: 'success',
          title: 'Thank you! We’ve received your inquiry and will get back to you as soon as we can.',
          showCancelButton: false,
        });
        setUserData({
          name: "",
          email: "",
          phone_code: "256",
          phone_number: "256",
          user_type: "",
          issue_type: "",
          message: "",
          attachment: null
        });
        setAddress(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      })
      .catch((error) => {
        MySwal.close();
        MySwal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.detail ? error.response?.data?.detail : 'Something went wrong!',
        });
        console.log(error);
      });
  }

  return (
    <>
      {/* banner area start + contact us section ( include all common classes ) */}
      <section className="main-banner-area contact-us-area">
        <Container>
          <div className="main-banner-inner">
            <Row className="align-items-center">
              <Col lg={6}>
                <div className="main-banner-content position-relative contact-us-card">
                  <h1>
                    <span>Contact Us </span>for any Enquiry
                  </h1>
                  <p>
                  Enjoy seamless convenience with Union Car and Boda , perfect for personal, corporate, and team travel needs.
                  </p>
                  <a href="tel:+0800280025">
                    <p className="toll-free-number">
                      <img
                        className="me-2"
                        alt="call-icon"
                        src={require("../assets/images/call-icon.svg").default}
                      />{" "}
                      Toll Free: 0800280025
                    </p>
                    </a>
                  <img
                    className="line-arrow position-absolute"
                    alt="line-img"
                    src={require("../assets/images/line-arrow.svg").default}
                  />{" "}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-banner-img">
                  <img
                    src={require("../assets/images/contact-us-img.svg").default}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      {/* banner area end + contact us section ( include all common classes ) */}
      {/* map section start */}
      <section className="map-view-section position-relative">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d502.03527078897594!2d32.61437541392617!3d0.2836635070022191!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbd006f475171%3A0xa37a4b9f2926f943!2sUnion%20Boda!5e1!3m2!1sen!2sin!4v1741149054208!5m2!1sen!2sin"
        allowFullScreen
        loading="lazy"
        style={{
          position: "absolute",
          top: 0,
          left: "-700px",
          width: "calc(100% + 700px)",
          height: "100%",
          border: "none",
        }}
        referrerPolicy="no-referrer-when-downgrade"
      />
        <Container>
          <Row className="justify-content-end">
            <Col md={12} lg={6}>
            <div className="outer-form-div">
              <h3>Fill the Form</h3>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name here..."
                  value={userData.name}
                  name="name"
                  maxLength={60}
                  onChange={(e) => handleUserInput('name', e.target.value)}
                  isInvalid={!!errors.name}
                />
                {errors.name && <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>}
              </Form.Group>
              <Row>
                <Col md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter your email here..."
                  value={userData.email}
                  maxLength={80}
                  onChange={(e) => handleUserInput('email', e.target.value)}
                  isInvalid={!!errors.email}
                />
                {errors.email && <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>}
              </Form.Group>
              </Col>
              <Col md={6}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Phone Number</Form.Label>
                <PhoneInput
                  country={"ug"}
                  value={userData.phone_number}
                  // countryCodeEditable={false}
                  onChange={handlePhoneChange}
                  inputClass="w-100 bg-transparent"
                  inputProps={{ name: "phone_number" }}
                  inputStyle={{
                    fontWeight: 400,
                    lineHeight: 1.5,
                    height: "48px",
                    border: "1px solid #b8b8b878",
                    fontSize: "1rem",
                    padding: "11px 48px 11px 48px",
                  }}
                  isInvalid={!!errors.phone_number}
                />
                {errors.phone_number && <Form.Control.Feedback className="d-block" type="invalid">{errors.phone_number}</Form.Control.Feedback>}
              </Form.Group>
              </Col>
              </Row>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Address</Form.Label>
                  <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_MAPS_API}
                    minLengthAutocomplete={3}
                    autocompletionRequest={{
                      componentRestrictions: {
                        country: ['ug']
                      }
                    }}
                    selectProps={{
                      value: address,
                      onChange: handleAddressChange,
                      placeholder: "Enter your address",
                      styles: {
                        container: (base, state) => ({
                          ...base,
                          borderRadius: "8px",
                          border: "1px solid #b8b8b878",
                          padding: "2px"
                        }),
                        control: (base, state) => ({
                          ...base,
                          border: "none",
                          backgroundColor: "transparent",
                        })
                      },
                    }}
                  />
                  {errors.address && <Form.Control.Feedback type="invalid" className="d-block">{errors.address}</Form.Control.Feedback>}
                </Form.Group>
                <Row>
                <Col md={6}>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>User Type</Form.Label>
                  <Select
                    options={userOptions}
                    placeholder="Select user type"
                    name="user_type"
                    value={userOptions.find(option => option.value === userData.user_type) || null}
                    onChange={(option) => handleUserInput('user_type', option.value)}
                  />
                  {errors.user_type && <Form.Control.Feedback type="invalid" className="d-block">{errors.user_type}</Form.Control.Feedback>}
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Issue Type</Form.Label>
                  <Select
                    options={issueOptions}
                    placeholder="Select issue type"
                    name="issue_type"
                    value={issueOptions.find(option => option.value === userData.issue_type) || null}
                    onChange={(option) => handleUserInput('issue_type', option.value)}
                  />
                  {errors.issue_type && <Form.Control.Feedback type="invalid" className="d-block">{errors.issue_type}</Form.Control.Feedback>}
                </Form.Group>
                </Col>
                </Row>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Message</Form.Label>
                <Form.Control as="textarea" rows={3} placeholder="Write your message here..." className="resize-none" value={userData.message} onChange={(e) => handleUserInput('message', e.target.value)}
                  isInvalid={!!errors.message} />
                {errors.message && <Form.Control.Feedback type="invalid">{errors.message}</Form.Control.Feedback>}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Additional PDF Attachment (Optional)</Form.Label>
                <Form.Control type="file" ref={fileInputRef} accept=".pdf" onChange={(e) => handleUserInput('attachment', e.target.files[0])} isInvalid={!!errors.attachment} />
                {errors.attachment && <Form.Control.Feedback type="invalid">{errors.attachment}</Form.Control.Feedback>}
              </Form.Group>

              <div className="captcha">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={handleCaptchaChange}
                  className="captcha-wrap"
                />
              </div>
              
              <Button className="primary-btns" type="submit" onClick={() => handleSubmit()} disabled={!captchaVerified}>
                Submit
              </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* map section end */}
    </>
  );
};
export default ContactUs;
